export const getCookie = (name = 'Authorization') => {
  let cookies = document.cookie.split('; ');  
  
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i].split('=');  
    if (cookie[0] === name) {
      return cookie[1];
    }
  }
  return null;
};
